<app-breadcrumb [title]="'Seguimientos'" [items]="['Pesv']" [active_item]="'Seguimientos'"></app-breadcrumb>

<div class="container-fluid">
    <div class="card">
        <div class="card-header d-flex align-items-center bg-primary text-white">
            <h5 class="mb-0"><strong>LISTADO DE SEGUIMIENTOS</strong></h5>
        </div>
        <div class="card-body pt-3">

            <div class="row mb-3 align-items-center">
                <div class="col-md-3">
                    <select class="form-select" [(ngModel)]="filtroEstado" (change)="filtrar()">
                        <option [ngValue]="null">Todos</option>
                        <option [ngValue]="1">Activos</option>
                        <option [ngValue]="0">Inactivos</option>
                    </select>
                </div>
                <div class="col-md-4 ms-auto">
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="Buscar por observación o responsable..."
                            [(ngModel)]="terminoBusqueda" (input)="filtrar()" />
                        <span class="input-group-text">
                            <i class="fa fa-search"></i>
                        </span>
                    </div>
                </div>
            </div>

            <!-- 🔹 Tabla -->
            <div class="table-responsive mt-2">
                <table id="tblSeguimientosPrograma" class="table table-bordered table-hover align-middle">
                    <thead class="bg-primary text-white">
                        <tr>
                            <th class="text-center">FECHA</th>
                            <th class="text-center">RESPONSABLE</th>
                            <th class="text-center">AVANCE</th>
                            <th class="text-center">RESULTADO</th>
                            <th class="text-center">OBSERVACIONES</th>
                            <th class="text-center">ESTADO</th>
                            <th class="text-center">ACCIONES</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-container *ngIf="!cargando; else cargandoTpl">
                            <tr
                                *ngFor="let segui of filteredSeguimientos | paginate: { itemsPerPage: pageSize, currentPage: page, id: 'actividadesPagination' }">
                                <td class="text-center">{{ segui.fechaCreacion | date: 'dd/MM/yyyy HH:mm:ss' }}</td>
                                <td class="text-center text-uppercase">{{ segui.nombre_responsable }} - ({{
                                    segui.PropietarioSeguimientoData?.cargoData?.cargos }})</td>
                                <td class="text-center" style="min-width: 140px;">
                                    <div class="progress" style="height: 18px;">
                                        <div class="progress-bar" [ngClass]="'bg-' + colorAvance(segui.avance)"
                                            [style.width.%]="segui.avance">
                                            {{ segui.avance }}%
                                        </div>
                                    </div>
                                </td>
                                <td class="text-center">
                                    <span class="badge rounded-pill"
                                        [ngClass]="getEstadoPlanBadgeClass(segui.resultado)">
                                        {{ segui.EstadoSeguimientoData?.descripcion }}
                                    </span>
                                </td>
                                <td style="max-width: 260px; white-space: normal;">{{ segui.observaciones }}</td>
                                <td class="text-center">
                                    <span class="badge" [ngClass]="getEstadoBadgeClass(segui.estado)">
                                        {{ segui.estadoLabel }}
                                    </span>
                                </td>
                                <td class="text-center">
                                    <div class="d-flex justify-content-center gap-1">
                                        <button class="btn btn-sm btn-outline-info rounded-pill btn-rounded"
                                                (click)="abrirModalDocumentos(modalDocumentosPlan, segui)"
                                                ngbTooltip="Documentos">
                                                <i class="icofont icofont-file-document" style="font-size: .85rem;"></i>
                                            </button>
                                        <ng-container *ngIf="segui.estado === 1; else accionesInactivoSeguimiento">
                                            <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                                (click)="abrirModalEditar(segui)" ngbTooltip="Editar">
                                                <i class="icofont icofont-pencil" style="font-size: .85rem;"></i>
                                            </button>
                                            <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                                (click)="cambiarEstado(segui)" ngbTooltip="Inactivar">
                                                <i class="icofont icofont-trash" style="font-size: .85rem;"></i>
                                            </button>
                                        </ng-container>
                                        
                                        <ng-template #accionesInactivoSeguimiento>
                                            <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                                (click)="cambiarEstado(segui)" ngbTooltip="Activar">
                                                <i class="icofont icofont-check" style="font-size: .85rem;"></i>
                                            </button>
                                        </ng-template>
                                    </div>
                                </td>
                            </tr>

                            <tr *ngIf="filteredSeguimientos.length === 0">
                                <td colspan="7" class="text-center text-primary py-4">
                                    No hay seguimientos registrados para este programa.
                                </td>
                            </tr>
                        </ng-container>

                        <ng-template #cargandoTpl>
                            <tr>
                                <td colspan="7" class="text-center py-4">
                                    <span class="spinner-border spinner-border-sm me-2"></span> Cargando...
                                </td>
                            </tr>
                        </ng-template>
                    </tbody>
                </table>

                <div class="d-flex justify-content-between align-items-center mt-4"
                    *ngIf="filteredSeguimientos?.length">
                    <div class="d-flex align-items-center">
                        <label class="me-2">Mostrar:</label>
                        <select class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                            <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                        </select>
                        <span class="ms-2">registros por página</span>
                    </div>
                    <div class="text-center flex-grow-1">
                        Total Registros:
                        <a class="badge badge-primary"><b>{{ filteredSeguimientos.length || 0 }}</b></a>
                    </div>
                    <div class="text-end paginador-personalizado">
                        <pagination-controls id="actividadesPagination" (pageChange)="page = $event" [maxSize]="5"
                            [directionLinks]="true" [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente">
                        </pagination-controls>
                    </div>
                </div>
            </div>

            <div class="mt-4">
                <div class="btn-showcase text-center">
                    <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                        (click)="exportarExcel('tblSeguimientosPrograma','Listado_Seguimientos')">
                        <i class="icofont icofont-file-excel"></i> EXCEL
                    </button>
                    <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                        (click)="exportToPDF('tblSeguimientosPrograma','Listado_Seguimientos','Listado de Seguimientos')">
                        <i class="icofont icofont-file-pdf"></i> PDF
                    </button>
                    <button class="btn btn-primary" (click)="abrirModalCrear()">
                        <i class="fa fa-plus me-1"></i> Nuevo seguimiento
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- 🔹 MODAL: sirve tanto para crear como para editar -->
<ng-template #modalSeguimiento let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            {{ modoEdicion ? 'Editar seguimiento' : 'Nuevo seguimiento' }}
        </h5>
        <button type="button" class="btn-close" (click)="cerrarModal()"></button>
    </div>

    <form [formGroup]="formSeguimiento" (ngSubmit)="guardar()">
        <div class="modal-body">
            <div class="row g-3">


                <div class="col-md-6">
                    <label class="form-label text-dark">Responsable: <span class="text-danger">*</span></label>
                    <ng-select [items]="responsables" bindLabel="nombreCompleto" bindValue="cedula"
                        placeholder="Seleccione un responsable" formControlName="responsable" [clearable]="true"
                        [searchable]="true"
                        [class.is-invalid]="formSeguimiento.get('responsable')?.invalid && formSeguimiento.get('responsable')?.touched">
                    </ng-select>
                    <div class="invalid-feedback d-block"
                        *ngIf="formSeguimiento.get('responsable')?.invalid && formSeguimiento.get('responsable')?.touched">
                        El responsable es obligatorio.
                    </div>
                </div>

                <div class="col-md-6">
                    <label class="form-label text-dark">(%) Avance : <span class="text-danger">*</span></label>
                    <input type="number" min="0" max="100" class="form-control" formControlName="avance"
                        [class.is-invalid]="formSeguimiento.get('avance')?.invalid && formSeguimiento.get('avance')?.touched" />
                </div>

                <div class="col-md-6">
                    <label class="form-label text-dark">Resultado: <span class="text-danger">*</span></label>

                    <ng-select [items]="estadosSeguimiento" bindLabel="descripcion" bindValue="id"
                        placeholder="Seleccione un estado" formControlName="resultado" [clearable]="true"
                        [searchable]="true"
                        [class.is-invalid]="formSeguimiento.get('resultado')?.invalid && formSeguimiento.get('resultado')?.touched">
                    </ng-select>
                </div>

                <div class="col-12">
                    <label class="form-label text-dark ">Observaciones: <span class="text-danger">*</span></label>
                    <textarea class="form-control" rows="3" maxlength="2000" formControlName="observaciones"
                        [class.is-invalid]="formSeguimiento.get('observaciones')?.invalid && formSeguimiento.get('observaciones')?.touched"></textarea>
                </div>

            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="cerrarModal()">Cancelar</button>
            <button type="submit" class="btn btn-primary" [disabled]="guardando">
                <span *ngIf="guardando" class="spinner-border spinner-border-sm me-1"></span>
                {{ modoEdicion ? 'Actualizar' : 'Guardar' }}
            </button>
        </div>
    </form>
</ng-template>

<ng-template #modalDocumentosPlan let-modal>
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title">
            Documentos — Seguimiento {{ seguimientoSeleccionadoDocs?.fechaCreacion | date: 'dd-MM-yyyy' }}
        </h5>
        <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">

        <!-- 🔒 Seguimiento inactivo: no se permite cargar documentos -->
        <div class="alert alert-secondary d-flex align-items-center mb-4"
            *ngIf="seguimientoSeleccionadoDocs?.estado === 0">
            <i class="icofont icofont-lock fs-5 me-2"></i>
            Este seguimiento está <strong class="mx-1">inactivo</strong>, por lo tanto no se pueden cargar ni modificar
            documentos.
        </div>

        <div class="mb-4" *ngIf="seguimientoSeleccionadoDocs?.estado !== 0">
            <input type="file" class="d-none" id="inputDocumentosPlan" multiple
                (change)="onFileChangeDocumento($event)">
            <label for="inputDocumentosPlan"
                class="dropzone-label w-100 d-flex flex-column align-items-center justify-content-center py-4 border border-primary rounded cursor-pointer">
                <i class="icofont icofont-upload fs-1 text-primary mb-2"></i>
                <p class="mb-2 text-black text-primary text-center">Haz click o arrastra archivos para cargar</p>
                <span class="btn btn-primary btn-sm rounded-pill px-3">Seleccionar archivos</span>
            </label>
        </div>

        <div *ngIf="nuevosArchivosDocs.length > 0 && seguimientoSeleccionadoDocs?.estado !== 0" class="mb-4">
            <h6 class="fw-bold">Archivos seleccionados</h6>
            <div class="row g-2">
                <div class="col-6 col-md-3" *ngFor="let item of nuevosArchivosDocs; let i = index">
                    <div class="card p-2 text-center h-100">
                        <img *ngIf="item.preview" [src]="item.preview" class="mb-1 rounded"
                            style="max-height: 90px; object-fit: cover;">
                        <i *ngIf="!item.preview" class="fa fa-file-pdf-o fs-2 text-danger mb-1"></i>
                        <small class="text-truncate d-block" [title]="item.file.name">{{ item.file.name }}</small>
                        <button class="btn btn-sm btn-outline-danger mt-1" (click)="quitarArchivoNuevo(i)">
                            <i class="bi bi-trash"></i> Quitar
                        </button>
                    </div>
                </div>
            </div>
            <button class="btn btn-success mt-3" [disabled]="subiendoDocumentos" (click)="subirDocumentosPlan()">
                <span *ngIf="subiendoDocumentos" class="spinner-border spinner-border-sm me-1"></span>
                <i class="icofont icofont-cloud-upload me-1"></i> Subir {{ nuevosArchivosDocs.length }} archivo(s)
            </button>
        </div>

        <hr>

        <h6 class="fw-bold text-dark">Documentos cargados</h6>
        <div *ngIf="cargandoDocumentos" class="text-center py-3">
            <div class="spinner-border text-primary"></div>
        </div>

        <div *ngIf="!cargandoDocumentos && documentosPlan.length === 0" class="text-primary text-center py-3">
            No hay documentos cargados para este Seguimiento.
        </div>

        <div class="row g-2" *ngIf="!cargandoDocumentos && documentosPlan.length > 0">
            <div class="col-12 col-md-4" *ngFor="let doc of documentosPlan">
                <div class="card p-2 text-center h-100">
                    <img *ngIf="doc.isImage" [src]="doc.url" class="mb-1 rounded cursor-pointer"
                        style="max-height: 90px; object-fit: cover;" (click)="verDocumento(modalVerDocumento, doc)">
                    <i *ngIf="!doc.isImage" class="fa fa-file-pdf-o fs-2 text-danger mb-1 cursor-pointer"
                        (click)="verDocumento(modalVerDocumento, doc)"></i>
                    <small class="text-truncate d-block" [title]="doc.name">{{ doc.name }}</small>
                    <div class="d-flex gap-1 justify-content-center mt-1">
                        <button class="btn btn-sm btn-outline-primary" (click)="verDocumento(modalVerDocumento, doc)">
                            <i class="icofont icofont-eye"></i>
                        </button>
                        <button class="btn btn-sm btn-outline-warning" *ngIf="seguimientoSeleccionadoDocs?.estado !== 0"
                            (click)="reemplazarDocumento(doc)">
                            <i class="icofont icofont-refresh"></i>
                        </button>
                        <button class="btn btn-sm btn-outline-danger" *ngIf="seguimientoSeleccionadoDocs?.estado !== 0"
                            (click)="eliminarDocumento(doc)">
                            <i class="icon-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cerrar</button>
    </div>
</ng-template>

<ng-template #modalVerDocumento let-modal>

    <div class="modal-body text-center" style="min-height: 60vh;">

        <img *ngIf="documentoSeleccionado?.isImage" [src]="documentoSeleccionado?.url" class="img-fluid rounded"
            style="max-height: 75vh;">

        <iframe *ngIf="documentoSeleccionado?.isPdf" [src]="documentoSeleccionado?.urlSegura"
            style="width: 100%; height: 75vh; border: none;">
        </iframe>

        <div *ngIf="!documentoSeleccionado?.isImage && !documentoSeleccionado?.isPdf"
            class="d-flex flex-column align-items-center justify-content-center py-5">
            <i class="fa fa-file-o fs-1 text-secondary mb-3"></i>
            <p class="text-muted">
                Este tipo de archivo no se puede previsualizar en el navegador.
            </p>
            <a [href]="documentoSeleccionado?.url" target="_blank" class="btn btn-primary">
                <i class="icofont icofont-download"></i> Descargar / Abrir
            </a>
        </div>

    </div>

    <div class="modal-footer">
        <a *ngIf="documentoSeleccionado?.isImage || documentoSeleccionado?.isPdf" [href]="documentoSeleccionado?.url"
            target="_blank" class="btn btn-outline-primary">
            <i class="icofont icofont-download"></i> Abrir en pestaña nueva
        </a>
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cerrar</button>
    </div>
</ng-template>